import { filterNulls as fn } from '../src/filterNulls.ts';
export const filterNulls = fn;
